import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import ConfirmForm from "../../components/forms/ConfirmForm";
import ProgressForm from "./PauseSubscriptionProgressForm";
import {cancelPauseSubscription} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class PauseSubscriptionFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      requestId: "",
      view: "confirm"
    }      
  }

  handleSubmit(values) {
    return this.props.pauseSubscription(values.set("subscriptionId", this.props.subscriptionId).toJS())
      .then((response) => {
        if (response.data.pauseSubscription.errors.length <= 0) {
          console.log("request id: ", response.data.pauseSubscription.requestId);
          this.setState({view: "monitor", requestId: response.data.pauseSubscription.requestId});
        } else {
          let errors = createValidationErrors(response.data.pauseSubscription.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelPauseSubscription();
  }

  handleBack() {
    this.setState({view: "confirm"});
  }

  handleCompleted() {
    this.props.cancelPauseSubscription(); 
  }

  render() {
    if (this.state.view === "monitor") {
      return this.renderMonitorView();
    }
    return this.renderConfirmView();
  }


  renderConfirmView() {
    return (
      <ConfirmForm
        errors={this.state.errors}
        message="Are you sure you want to pause this subscription?"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

  renderMonitorView() {
    return (
      <ProgressForm
        subscriptionId={this.props.subscriptionId}
        requestId={this.state.requestId}
        onBack={this.handleBack.bind(this)}
        onCompleted={this.handleCompleted.bind(this)}
        />
    )
  }    

}

const PAUSE_SUBSCRIPTION = gql`
  mutation pauseSubscription($subscriptionId: ID!) {
    pauseSubscription(subscriptionId: $subscriptionId) {
      requestId
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(PAUSE_SUBSCRIPTION, {
    props: ({ mutate }) => ({
      pauseSubscription: (data) => mutate({
        variables: data
      })
    })
  })
);

export default connect(null, {cancelPauseSubscription})(withQueries(PauseSubscriptionFormContainer));